import React from 'react';
import { useTranslation } from 'react-i18next';
import avatar from 'Assets/layout/prosJobList/avatar-yellow.svg';
import AvatarStack, { AvatarStackPro } from 'Douleutaras/components/AvatarStack/AvatarStack';

import ProsBannerSubtitle from './ProsBannerSubtitle';
import { getProsBannerCounts } from './prosBannerCounts';
import './PersonalDetailsProsBanner.scss';

export interface PersonalDetailsProsBannerProps {
  // Bid objective for the subcategory/location (posting_flow `max_bids`).
  bidObjective: number;
  // Total available professionals (posting_flow `pros_available_info.pros_available`).
  // Undefined when availability info is unknown — the +X counter is then hidden.
  availableProfessionals?: number;
}

const PersonalDetailsProsBanner = ({ bidObjective, availableProfessionals }: PersonalDetailsProsBannerProps) => {
  const { t } = useTranslation();

  const { avatarCount, extraAvailable } = getProsBannerCounts(bidObjective, availableProfessionals);

  // No pro-mugshots are available at this step, so the stack is filled with a
  // generic placeholder avatar. `isTopPro` gives each item the yellow ring from
  // the design (it only tints the ring — it does not add a top-pro badge).
  const avatarStackPros: Array<AvatarStackPro> = Array.from({ length: avatarCount })
    .map((unused, index) => ({
      id: `pros-banner-avatar-${index}`,
      mugshot: avatar,
      name: '',
      isTopPro: false
    }));

  return (
    <>
    <div styleName="pros-banner">
      <div styleName="pros-banner__content">
        <p styleName="pros-banner__title">
          {t('T.POST-JOB.PROS-BANNER.TITLE', 'Good news!')}
        </p>
        <p styleName="pros-banner__subtitle">
          <ProsBannerSubtitle bidObjective={bidObjective} extraAvailable={extraAvailable} />
        </p>
      </div>
      <AvatarStack pros={avatarStackPros} totalCount={extraAvailable} size="small" />
    </div>
    <p styleName="pros-banner-prompt">
      {t('T.POST-JOB.PROS-BANNER.DETAILS-PROMPT', 'Fill in your details to get quotes right away.')}
    </p>
    </>
  );
};

export default PersonalDetailsProsBanner;
